import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { actions } from 'react-redux-form';
import { savePersonalRewards } from '../../../actions/staff';
import UserDetailsForm from './ppc-user-form';
import { getMyProfile } from '../../../actions/user';

import './styles.css';

class YourPersonalRewards extends Component {
  onSubmit = (payLoad) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields('deep.personal_rewards', savePersonalRewards(payLoad)))
      .then(() => dispatch(getMyProfile('CURRENT_USER_PROFILE')));
  };

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(actions.reset('deep.personal_rewards'));
  }

  render() {
    return (
      <Modal
        aria-labelledby="contained-modal-title"
        className="personal-rewards-popup"
        show
      >
        <Modal.Header>
          <Modal.Title>
            YOUR PERSONAL REWARDS
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            In order to receive your personal rewards, you will need to opt in to the ignite Prepaid Mastercard by
            completing the form
            below. Please ensure that all the details you provide are accurate to avoid any problems issuing your prepaid
            card.
          </p>
          <UserDetailsForm onSubmit={this.onSubmit} />
        </Modal.Body>
      </Modal>
    );
  }
}

export default connect(null)(YourPersonalRewards);



// WEBPACK FOOTER //
// ./src/components/home/personal-rewards/index.jsx